import { UntypedFormGroup } from '@angular/forms';
import { isValidPhoneNumber, getCountries } from 'libphonenumber-js';
import { Country } from '../country/Country';


// custom validator to check that two fields match
export function IsPhoneNumberValid(countryCodeFieldName: string, phoneNumberFieldName: string) {

    return (formGroup: UntypedFormGroup) => {
        const countryCodecontrol = formGroup.controls[countryCodeFieldName];
        const phoneNumberControl = formGroup.controls[phoneNumberFieldName];
        const countriesJsonString = localStorage.getItem('countries');
        const countries: Country[] = countriesJsonString ?  JSON.parse(countriesJsonString) : [];
        const country: Country | undefined =  countries.find((country) => { return country.id == countryCodecontrol.value});

        const phoneNumber = phoneNumberControl.value;

        // Special validation for Cameroon (ID: 37, ISO: CM) - must be exactly 9 digits
        if (country && country.id === 37) {
            const cameroonPhoneRegex = /^\d{9}$/;
            if (cameroonPhoneRegex.test(phoneNumber)) {
                phoneNumberControl.setErrors(null);
            } else {
                phoneNumberControl.setErrors({cameroonPhoneMustBe9Digits:true});
            }
            return;
        }

        const cc =  country ? getCountries().find((c) => { return c == country.iso}) : undefined;

        if(country != null && cc && isValidPhoneNumber(phoneNumberControl.value, cc)) {
            phoneNumberControl.setErrors(null);
        } else {
            phoneNumberControl.setErrors({phoneMustValid:true});
        }
        // set error on matchingControl if validation fails

    };
}
